import {Component, forwardRef, OnInit} from '@angular/core';
import {AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator} from '@angular/forms';

@Component({
  selector: 'app-salary-field',
  templateUrl: './salary-field.component.html',
  styleUrls: ['./salary-field.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SalaryFieldComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SalaryFieldComponent),
      multi: true,
    }
  ]
})
export class SalaryFieldComponent implements ControlValueAccessor, Validator {

  salary$ = [
    {label: 'לא צויין שכר', id: 'לא צויין שכר'},
    {label: '35+ לשעה', id: '35+'},
    {label: '40+ לשעה', id: '40+'},
    {label: '45+ לשעה', id: '45+'},
    {label: '50+ לשעה', id: '50+'},
    {label: 'גלובלי', id: 'גלובלי'},
    {label: 'שכר אש', id: 'שכר אש'},
    {label: 'שכר וטיפים', id: 'שכר וטיפים'},
    {label: 'אחר', id: 'אחר'}
  ];

  salaryLabel$ = [
    {label: 'לא צויין שכר'},
    {label: '35+'},
    {label: '40+'},
    {label: '45+'},
    {label: '50+'},
    {label: 'גלובלי'},
    {label: 'שכר אש'},
    {label: 'שכר וטיפים'},
    {label: 'אחר'},
  ];
  active = false;

  control: AbstractControl;
  value: any;

  constructor() { }

  registerOnChange(fn: any): void {

    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  private propagateChange = (_: any) => { };

  private onTouched: () => void = () => {
    this.control.markAsDirty({onlySelf: true});
  }

  registerOnValidatorChange(fn: () => void): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  validate(control: AbstractControl): ValidationErrors | null {
    console.log(control.value);
    if (control.value === 'אחר') {
      this.active = true;
    }
    this.control = control;
    return undefined;
  }

  writeValue(value: any): void {
    if (value) {
      this.value = value;
      this.active = this.salaryLabel$.indexOf({label: this.value}) === -1;
    }
  }

}
